const AccountTitleDetailEvent = {
  fetchDetails: 'account-title-detail/fetch-details',
  fetchOne: 'account-title-detail/fetch-one',
  onEdit: 'account-title-detail/on-edit',
  onClear: 'account-title-detail/on-clear'
}

export default AccountTitleDetailEvent
